var _defs, _g, _script;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLeavesPulse = function SvgLeavesPulse(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "evgScnhwTRm1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95 74",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evgScnhwTRm4-fill",
    x1: 244.1174,
    y1: 120.6636,
    x2: 414.1205,
    y2: 75.5116,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm4-fill-0",
    offset: "0%",
    stopColor: "#004ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm4-fill-1",
    offset: "28.73%",
    stopColor: "#006ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm4-fill-2",
    offset: "71.21%",
    stopColor: "#00b1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm4-fill-3",
    offset: "76.91%",
    stopColor: "#00b8ac"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm4-fill-4",
    offset: "88.34%",
    stopColor: "#00c87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm4-fill-5",
    offset: "100%",
    stopColor: "#00dc48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evgScnhwTRm5-fill",
    x1: 250.6021,
    y1: 144.6089,
    x2: 420.6051,
    y2: 99.4569,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm5-fill-0",
    offset: "0%",
    stopColor: "#004ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm5-fill-1",
    offset: "28.73%",
    stopColor: "#006ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm5-fill-2",
    offset: "71.21%",
    stopColor: "#00b1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm5-fill-3",
    offset: "76.91%",
    stopColor: "#00b8ac"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm5-fill-4",
    offset: "88.34%",
    stopColor: "#00c87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm5-fill-5",
    offset: "100%",
    stopColor: "#00dc48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evgScnhwTRm6-fill",
    x1: 244.3586,
    y1: 121.1016,
    x2: 414.3617,
    y2: 75.9495,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm6-fill-0",
    offset: "0%",
    stopColor: "#004ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm6-fill-1",
    offset: "28.73%",
    stopColor: "#006ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm6-fill-2",
    offset: "71.21%",
    stopColor: "#00b1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm6-fill-3",
    offset: "76.91%",
    stopColor: "#00b8ac"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm6-fill-4",
    offset: "88.34%",
    stopColor: "#00c87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm6-fill-5",
    offset: "100%",
    stopColor: "#00dc48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "evgScnhwTRm7-fill",
    x1: 253.8532,
    y1: 156.85,
    x2: 423.8563,
    y2: 111.6979,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm7-fill-0",
    offset: "0%",
    stopColor: "#004ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm7-fill-1",
    offset: "28.73%",
    stopColor: "#006ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm7-fill-2",
    offset: "71.21%",
    stopColor: "#00b1be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm7-fill-3",
    offset: "76.91%",
    stopColor: "#00b8ac"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm7-fill-4",
    offset: "88.34%",
    stopColor: "#00c87e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "evgScnhwTRm7-fill-5",
    offset: "100%",
    stopColor: "#00dc48"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.946438-31.687155)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.197688-.000022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "evgScnhwTRm4",
    d: "M307.179999,88.270001h-20.859999v7.65C286.32,108.93,296.159999,119.48,308.299998,119.48h20.069999v-8.48c0-12.549999-9.499999-22.729999-21.189998-22.729999ZM320.469998,111.55h-12.17c-7.689999,0-13.949999-6.87-14.079999-15.359999h12.97c7.329999,0,13.289999,6.64,13.289999,14.819999v.54Z",
    transform: "matrix(-1 0 0-1 378.894356 151.167171)",
    fill: "url(#evgScnhwTRm4-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evgScnhwTRm5",
    d: "M335.32,123.75v8.47h20.07c12.14,0,21.98-10.55,21.98-23.56v-7.65h-20.87c-11.68,0-21.18,10.18-21.18,22.74Zm7.9,0c0-8.17,5.96-14.82,13.29-14.82h12.97c-.14,8.49-6.39,15.36-14.08,15.36h-12.17v-.54Z",
    transform: "translate(-284.571269-27.072823)",
    fill: "url(#evgScnhwTRm5-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evgScnhwTRm6",
    d: "M384.58,85.5v8.47h20.07c12.14,0,21.98-10.55,21.98-23.56v-7.65h-20.86c-11.69,0-21.19,10.19-21.19,22.74Zm7.9,0c0-8.17,5.96-14.82,13.29-14.82h12.97c-.14,8.49-6.39,15.36-14.08,15.36h-12.17v-.54Z",
    transform: "translate(-280.966694-31.072832)",
    fill: "url(#evgScnhwTRm6-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "evgScnhwTRm7",
    d: "M405.28,100.99h-20.86v7.65c0,13.01,9.84,23.56,21.98,23.56h20.07v-8.47c0-12.56-9.5-22.74-21.19-22.74Zm13.29,23.28h-12.17c-7.69,0-13.95-6.87-14.08-15.36h12.97c7.33,0,13.29,6.64,13.29,14.82v.54Z",
    transform: "matrix(1 0.000035-.000035 1-280.802115-27.087047)",
    fill: "url(#evgScnhwTRm7-fill)"
  })))), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLeavesPulse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leaves-pulse.bf07c26666634360cd06161db819f011.svg";